import { useEffect, useState } from 'react';
import { useConfiguration } from '../../app/api/configuration';
import { registerDynamicFederation } from '../../app/components/wealth/balanceEntryModal/clm/federation.util';
import { useLoadingElement } from '../../app/utils/useLoadingElement';
import type { PcmModalType } from '../types/PcmPartnerRelationModal';

const pcmPartnerRelationModuleMap: Record<PcmModalType, string> = {
    CreatePartnerRelation: 'pcm-create-partner-relation-modal',
    DeletePartnerRelation: 'pcm-delete-partner-relation-modal',
    UpdatePartnerRelation: 'pcm-update-partner-relation-modal',
};

type FederatedModuleStatus = 'loading' | 'done' | 'error';

/**
 * Load CLM partner data web components
 *
 * @param pcmPartnerRelationModalType
 */
export default function useFederatedPartnerDataModule(pcmPartnerRelationModalType: PcmModalType) {
    const moduleName = pcmPartnerRelationModuleMap[pcmPartnerRelationModalType];
    const [status, setStatus] = useState<FederatedModuleStatus>('loading');
    const isLoading = useLoadingElement(moduleName);
    const { data: configuration } = useConfiguration();

    useEffect(() => {
        (async function () {
            try {
                if (configuration && !customElements.get(moduleName)) {
                    registerDynamicFederation(
                        'pcm',
                        `./${moduleName}`,
                        `${configuration.clmPartnerDataMicroFrontendHost}/assets/remoteEntry.js`,
                        'esm',
                        'vite',
                    );
                }
                if (!isLoading) {
                    setStatus('done');
                }
            } catch (e) {
                console.error(e);
                setStatus('error');
            }
        })();
    }, [pcmPartnerRelationModalType, isLoading, moduleName, configuration]);

    return { status };
}
